export default "__VITE_ASSET__PGD2Va27__"